export default __webpack_public_path__ + "static/O0287-7e65086bad7f85216241552e0ae4c3f3.png";